module.exports = __webpack_public_path__ + "img/dispose9.d2c2abc7.png";